var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.929,
    height: 143.511,
    viewBox: "0 0 128.929 143.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_1_",
    "data-name": "chat (1)",
    transform: "translate(-26.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M113.314,256.688a2.1,2.1,0,0,0-2.1,2.1v53.363a11.906,11.906,0,0,1-11.893,11.893H42.109a11.907,11.907,0,0,1-11.893-11.893v-9.376a2.1,2.1,0,0,0-4.2,0v9.376a16.116,16.116,0,0,0,16.1,16.1H99.319a16.116,16.116,0,0,0,16.1-16.1V258.79A2.1,2.1,0,0,0,113.314,256.688Z",
    transform: "translate(0 -184.74)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M173.347,30.2a2.1,2.1,0,0,0,0-4.2h-8.611a2.1,2.1,0,0,0,0,4.2Z",
    transform: "translate(-98.328 -18.712)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M94.136,298.035v30.9H89.173a2.1,2.1,0,1,0,0,4.2h40.384a6.192,6.192,0,0,0,6.185-6.185V298.035a6.192,6.192,0,0,0-6.185-6.185H100.321A6.192,6.192,0,0,0,94.136,298.035Zm28.491,30.9H107.143v-5a5.627,5.627,0,0,1,5.621-5.621h.018v3.037a2.1,2.1,0,0,0,4.2,0v-3.037h.019a5.627,5.627,0,0,1,5.621,5.621Zm-11.033-18.112v-4.639a.334.334,0,0,1,.334-.334h5.912a.334.334,0,0,1,.334.334v4.639a3.29,3.29,0,0,1-6.58,0Zm19.944-12.786v28.918a1.983,1.983,0,0,1-1.981,1.981h-2.726v-5a9.837,9.837,0,0,0-5.733-8.929,7.452,7.452,0,0,0,1.281-4.186v-4.639a4.544,4.544,0,0,0-4.539-4.538h-5.912a4.544,4.544,0,0,0-4.539,4.538v4.639a7.452,7.452,0,0,0,1.281,4.186,9.837,9.837,0,0,0-5.733,8.929v5h-2.617a1.983,1.983,0,0,1-1.981-1.981V298.035a1.983,1.983,0,0,1,1.981-1.981h29.237A1.983,1.983,0,0,1,131.538,298.035Z",
    transform: "translate(-43.945 -210.046)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M143.373,25.426H115.418V16.1A16.116,16.116,0,0,0,99.32,0H42.109a16.116,16.116,0,0,0-16.1,16.1v92.069a2.1,2.1,0,1,0,4.2,0V16.1A11.906,11.906,0,0,1,42.109,4.2H99.32A11.906,11.906,0,0,1,111.213,16.1v9.328h-3.086V16.588a9.311,9.311,0,0,0-9.3-9.3H86.292a2.1,2.1,0,0,0-1.863,1.129l-3,5.749a1.329,1.329,0,0,1-1.181.716H61.183A1.335,1.335,0,0,1,60,14.166L57,8.417a2.1,2.1,0,0,0-1.863-1.129H42.6a9.311,9.311,0,0,0-9.3,9.3V126.923a9.311,9.311,0,0,0,9.3,9.3H98.827a9.311,9.311,0,0,0,9.3-9.3V66.277h35.246a11.581,11.581,0,0,0,11.568-11.568V36.993a11.581,11.581,0,0,0-11.567-11.567Zm-39.451,101.5a5.1,5.1,0,0,1-5.1,5.1H42.6a5.1,5.1,0,0,1-5.1-5.1V16.588a5.1,5.1,0,0,1,5.1-5.1H53.861l2.414,4.623a5.53,5.53,0,0,0,4.909,2.97H80.246a5.52,5.52,0,0,0,4.908-2.973l2.412-4.62H98.827a5.1,5.1,0,0,1,5.1,5.1v8.838H77.491A11.581,11.581,0,0,0,65.924,36.993V74.47a3.983,3.983,0,0,0,2.663,3.787,4.076,4.076,0,0,0,1.382.243,3.982,3.982,0,0,0,3.083-1.468l8.877-10.754h21.994ZM150.736,54.71a7.372,7.372,0,0,1-7.363,7.363H80.938a2.1,2.1,0,0,0-1.621.764L70.128,73.968V36.993a7.372,7.372,0,0,1,7.363-7.363h65.882a7.372,7.372,0,0,1,7.363,7.363V54.71Z",
    transform: "translate(-0.001)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M227.934,125.433h8.8a2.1,2.1,0,0,0,0-4.2h-8.8a2.1,2.1,0,0,0,0,4.2Z",
    transform: "translate(-143.812 -87.249)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M283.634,151.946h-55.7a2.1,2.1,0,0,0,0,4.2h55.7a2.1,2.1,0,0,0,0-4.2Z",
    transform: "translate(-143.812 -109.356)",
    fill: "#f2025d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M272.532,182.662h-44.6a2.1,2.1,0,0,0,0,4.2h44.6a2.1,2.1,0,0,0,0-4.2Z",
    transform: "translate(-143.812 -131.463)",
    fill: "#f2025d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.0477e630cfd4fdb31f4115ab7545b073.svg";
export { ForwardRef as ReactComponent };